"use strict";
/**
 * @author Pkr
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var ApprovalReportPMRowDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ApprovalReportPMRowDTOConverter, _DataObjectConverter_);

  function ApprovalReportPMRowDTOConverter() {
    _classCallCheck(this, ApprovalReportPMRowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ApprovalReportPMRowDTOConverter).apply(this, arguments));
  }

  return ApprovalReportPMRowDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ApprovalReportPMRowDTOConverter = ApprovalReportPMRowDTOConverter;